import { Helmet } from 'react-helmet';
import { withTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { ContainerComponent, ParagraphComponent, SubtitleComponent, TitleComponent } from '../../components';
import './unsubscribe.style.scss';

function Unsubscribe({ t }: { t: any }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const rawEmail = params.get('email') || '';
  let email = rawEmail.trim();

  try {
    email = decodeURIComponent(rawEmail).trim();
  } catch (error) {
    email = rawEmail.trim();
  }

  if (!email.includes('@')) {
    email = '';
  }

  return (
    <div className='unsubscribePage'>
      <Helmet>
        <title>{t('unsubscribe.meta.title')}</title>
        <meta name="description" content={t('unsubscribe.meta.description')} />
      </Helmet>
      <ContainerComponent>
        <div className="unsubscribeCard">
          <ParagraphComponent className='unsubscribeEyebrow'>{t('unsubscribe.eyebrow')}</ParagraphComponent>
          <TitleComponent smaller>{t('unsubscribe.title')}</TitleComponent>
          <SubtitleComponent className='unsubscribeMessage'>{t('unsubscribe.message')}</SubtitleComponent>
          {email ? (
            <ParagraphComponent className='unsubscribeEmail'>
              {t('unsubscribe.emailNotice', { email })}
            </ParagraphComponent>
          ) : null}
          <ParagraphComponent>{t('unsubscribe.fallback')}</ParagraphComponent>
        </div>
      </ContainerComponent>
    </div>
  )
}

export default withTranslation()(Unsubscribe);
